<template>
  <div id="btmWarp" class="btm-warp-list">
    <div class="btm-catgory-tab" :class="{'active-fixed': isFixed}" :style="{top: fixedTop}">
      <div class="btm-tab-warp">
        <div v-for="item in btmCategoryNav" :key="item.productCateId" :class="{'active': curproductCateId == item.productCateId}" @click="changeTab(item,$event)">
          <h6>{{item.name}}</h6><span>{{item.tag}}</span>
        </div>
      </div>
    </div>
    <div class="btm-category-warp" v-if="isOnline">
      <div class="category-empty" v-if="!productCateList.length && fetchEnd">
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/order/card-empty.png" alt="">
        <div class="loading-text">没有相关内容~</div>
      </div>
      <div id="btmCateList" class="btm-category-list" :class="{'btm-category-pt': isFixed}" v-else>
        <lazy-public-product-list id='pop-up-hidden' :productList="productCateList" :switchStyle='true' />
      </div>
      <div id="loadElem" class="loading-text">
        <div v-if="!fetchEnd">加载中...</div>
        <div v-else>没有更多了</div>
      </div>
    </div>
    <div class="btm-category-warp" v-else>
      <div class="category-empty">
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/order/card-empty.png" alt="">
        <div class="loading-text">没有相关内容~</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../api';
import { categoryNav } from '../common'
const lazyPublicProductList = () => import(/* webpackChunkName: "productList" */'@/components/publicProductList/index')

let scrollBindFn = null

export default {
  name: 'btmProducts',
  components: {
    lazyPublicProductList
  },
  props: {
    location: {
      type: Object,
      default: () => {}
    },
    isOnline: {
      type: Boolean,
      default: () => true
    }
  },
  directives: {
    scroll: {
      bind: function(el, binding) {
        scrollBindFn = (ev) => {
          let fixedTop = document.getElementById('btmWarp') && document.getElementById('btmWarp').offsetTop
          let topBarHeight = document.getElementById('topWarp') && document.getElementById('topWarp').offsetHeight
          console.log('scrollBindFn topBarHeight===>', topBarHeight)
          if (el?.getBoundingClientRect().top < window.innerHeight + 200) {
            binding.value('fetch')
          }
          if (ev.target.scrollTop >= fixedTop) {
            binding.value('fixed', topBarHeight)
          } else {
            binding.value('fixed', 0)
          }
        }
        document.getElementById('app-warp').addEventListener('scroll', scrollBindFn)
      }
    }
  },
  data() {
    return {
      isFixed: false,
      fixedTop: '',
      curproductCateId: 2729,
      cateName: '空调', // 分类名称
      btmCategoryNav: categoryNav,
      productCateList: [],
      fetching: false,
      fetchEnd: false,
      curpage: 1,
      pageSize: 10,
      IntersectionObserver: null
    }
  },
  mounted() {
    this.fetchData()
    document.getElementById('app-warp').addEventListener('scroll', this.scrollBindFn)
  },
  beforeDestroy() {
    document.getElementById('app-warp').removeEventListener('scroll', this.scrollBindFn)
    this.IntersectionObserver && this.IntersectionObserver.disconnect()
  },
  watch: {
    isOnline(newVal) {
      if (newVal) {
        this.fetchData()
      }
    }
  },
  methods: {
    scrollBindFn(ev) {
      let el = document.getElementById('loadElem')
      let fixedTop = document.getElementById('btmWarp') && document.getElementById('btmWarp').offsetTop
      let topBarHeight = document.getElementById('topWarp') && document.getElementById('topWarp').offsetHeight
      if (el && el.getBoundingClientRect().top < window.innerHeight + 200) {
        this.scrollFn('fetch')
      }
      if (ev.target.scrollTop >= fixedTop) {
        this.scrollFn('fixed', topBarHeight)
      } else {
        this.scrollFn('fixed', 0)
      }
    },
    scrollFn(status, position) {
      if (status === 'fetch') {
        this.fetchData()
      }
      if (status === 'fixed') {
        if (position) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
        this.fixedTop = position + 'px'
      }
    },
    fetchData(flag) {
      if (this.fetching || this.fetchEnd) return
      this.fetching = true;
      Api.getCommonLoadItemNew({
        pholder: 1,
        productCateId: this.curproductCateId,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        districtId: this.location.districtId,
        streetId: this.location.townshipId,
        fromType: 1,
        memberId: '',
        qs: 'isHotDesc',
        filterData: '',
        pageIndex: this.curpage,
        pageSize: this.pageSize,
        longitude: this.location.longitude || '',
        latitude: this.location.latitude || '',
      }).then(res => {
        let result = res.data;
        if (result.success) {
          let productList = result.data.productList
          let traceId = result.data.traceId
          if (productList.length && traceId) {
            Api.getPriceByProduct({ traceId }).then(({ data }) => {
              if (data.success) {
                let prodsArr = data.products
                productList.forEach(item => {
                  prodsArr.forEach(prod => {
                    if (prod.sku === item.sku) {
                      item.finalPrice = prod.lowestFlashPrice || prod.finalPrice
                      item.price = item.finalPrice
                      item.isLowestFlash = !!prod.lowestFlashPrice
                      item.skku = prod.skku
                      item.commission = prod.commission
                      item.commissionType = prod.commissionType
                      item.firstImageInfo = prod.firstImageInfo
                      item.priceType = prod.priceType
                      item.defaultPrice = prod.defaultPrice
                      item.promotion = prod.promotion
                      item.productActNew = prod.productActNew
                      item.productActTerm = prod.productActTerm
                      item.plusPrice = prod.plusPrice
                      item.clustersNum = prod.clustersNum
                      item.marketingTagList = prod.marketingTagList || []
                      item.giftCoupon = prod.giftCoupon
                    }
                  })
                })
                if (flag) this.productCateList = []
                this.productCateList = this.productCateList.concat(productList)
                console.log('productCateList==>',this.productCateList)
                this.productCateList.forEach((item, index) => {
                  item.listIndex = index
                  item.productCateId = this.curproductCateId
                })
                this.fetching = false;
                this.curpage += 1;

                if (productList.length < this.pageSize) {
                  this.fetchEnd = true
                }
                window.setTimeout(() => {
                  this.createIntersectionObserver()
                }, 500)
              }
            })
          } else {
            if (flag) this.productCateList = []
            this.fetchEnd = true
          }
        }
      }).catch(() => {
        this.fetchEnd = true
      })
    },
    createIntersectionObserver () {
      const options = {
        root: document.querySelector('#app'),
        rootMargin: '50px 0px',
        threshold: 0.8
      }
      if (this.IntersectionObserver) {
        this.IntersectionObserver.disconnect()
      }
      this.IntersectionObserver = new IntersectionObserver((entries) => {
        for (const ent of entries) {
          if (ent.isIntersecting) {
            console.log('btm===>', ent)
            this.$util.gioTrackWithVariable('MB13405', {
              // user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
              // member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
              roughly_classification_id: this.curproductCateId ? this.curproductCateId + '' : 'null',
              productId_var: ent.target.dataset.id + '',
              site_number: ~~ent.target.dataset.index + 1 + ''
            })
          }
        }
      }, options)
      for (const dom of document.querySelectorAll('.public-double-row-goods')) {
        this.IntersectionObserver.observe(dom)
      }
    },

    changeTab(item, ev) {
      // 埋点
      this.$util.gioTrackWithVariable('WBSC20006', {
        roughly_classification_id: item.productCateId,
        roughly_classification_name: item.name
      })
      this.cateName = item.name
      this.curproductCateId = item.productCateId
      this.fetching = false
      this.fetchEnd = false
      this.curpage = 1
      this.fetchData(true)
      this.$nextTick(() => {
        ev.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      })
      if (this.isFixed) {
        // document.getElementById('btmWarp').scrollIntoView({ behavior: 'smooth', block: 'start' })
        let positon = document.getElementById('btmCateList').offsetTop
        document.getElementById('app-warp').scroll(0, positon + 10)
      }
    },

    toProduct(prod) {
      this.$router.push(`/goodsDetail?productId=${prod.productId}`)
    }
  }
}
</script>

<style lang="scss" scoped>

.btm-warp-list{
  padding: .32rem 0;
  background: #f6f6f6;
  padding-top: .24rem;
}

.btm-catgory-tab{
  height: 1rem;
  overflow: hidden;
}

.active-fixed{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  background: #fff;
  padding-top: .2rem;
  height: .7rem;
  @include max-width;
  box-shadow: 0 .2rem .2rem rgba(0, 0, 0, .1);
  .btm-tab-warp{
    > div{
      margin-right: .49rem;
      h6{
        margin-bottom: .04rem;
        font-size: .28rem;
        line-height: .32rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
      }
      &.active{
        h6{
          font-size: .36rem;
          line-height: .36rem;
        }
        &::after{
          content:'';
          width: .34rem;
          height: .12rem;
          background: url('https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/home-tab-active-icon.png') center center no-repeat;
          background-size: cover;
        }
      }
    }
    span{
      display: none;
      font-size: 0;
      line-height: 0;
      width: 60%;
      padding: .04rem 0 !important;
    }
  }
}

.btm-tab-warp{
  padding: 0 .22rem;
  height: 1.1rem;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  > div{
    margin-right: .15rem;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 .1rem;
    vertical-align: top;
    &:last-child{
      margin-right: 0;
    }
    &.active{
      h6{
        color: $themeSynMain;
      }
      span{
        padding: .06rem .12rem;
        background: $themeSynMain;
        color: #fff;
        border-radius: .2rem;
      }
    }
    h6{
      margin-bottom: .14rem;
      font-size: .36rem;
      line-height: .36rem;
      font-weight: bold;
      color: #333;
      padding-top: .04rem;
    }
    span{
      font-size: .2rem;
      color: #999;
      line-height: .28rem;
    }
  }
}

.btm-category-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  transition: all .2s linear;
}
.btm-category-pt{
  padding-top: .6rem;
}
.btm-category-list{
  :deep(.double-list) {
    padding: 0 0.32rem;
  }
  :deep(.public-double-row-goods) {
    width: 3.36rem;
    .left img{
      width: 3.36rem;
      height: 3.36rem;
    }
  }
}

.category-empty{
  padding-top: .4rem;
  text-align: center;
  img{
    display: inline-block;
    max-width: 40%;
  }
}

.btm-list-item{
  display: inline-block;
  margin-bottom: .24rem;
  width: 3.44rem;
  padding: .24rem;
  background: #fff;
  border-radius: .16rem;
  box-sizing: border-box;
  .btm-item-img{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    overflow: hidden;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
  .btm-item-name{
    margin-top: .16rem;
    margin-bottom: .08rem;
    height: .7rem;
    font-size: .24rem;
    color: #333;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    line-height: .35rem;
    span{
      margin-right: 2px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: .6rem;
      height: .28rem;
      border-radius: .04rem;
      font-size: .22rem;
      color: #fff;
      background: #ED2856;
    }
  }

  .btm-item-sellpoint{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: .1rem;
    height: .44rem;
    overflow: hidden;
    span{
      color: #666666;
      margin-right: .1rem;
      margin-bottom: .12rem;
      background-color: #f6f6f6;
      border-radius: 0.14rem;
      padding: .06rem .08rem;
      font-size: .2rem;
    }
  }

  .btm-item-footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .disabled{
      color: #999;
    }
    p{
      font-size: .32rem;
      font-weight: bold;
      color: #ED2856;
      span{
        font-size: .28rem;
        font-weight: normal;
      }
    }
    strong{
      font-size: .24rem;
      font-weight: normal;
      color:$themeSynMain;
    }
  }
}

.btm-item-commit{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span{
    margin-right: .16rem;
    padding: .2rem 0;
    padding-bottom: 0;
    font-size: .24rem;
    color: #999;
  }
}

.loading-text{
  padding: .2rem 0;
  margin-bottom: 1.2rem;
  text-align: center;
  font-size: .28rem;
  color: #969799;
}
</style>
